// extracted by mini-css-extract-plugin
export default {"progress":"NotificationMessage_progress__rmof9","progressActive":"NotificationMessage_progressActive__1gQ7o","message":"NotificationMessage_message__2igIj"};